<template>
  <v-card flat>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{ text }}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <!-- <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-btn class="primary" round @click="save">Save Changes</v-btn>
    </v-toolbar> -->
    <v-layout wrap justify-start>
      <v-flex
        xs12
        md4
        style="
          border-left: 1px solid lightgrey;
          border-right: 1px solid lightgrey;
          border-bottom: 1px solid lightgrey;
        "
      >
        <v-list subheader>
          <v-subheader style="background: #f0f0f0">
            General Information <v-spacer></v-spacer>
            <v-btn icon @click="editGeneralInformation = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon v-if="addressinfo.backhaulType == 'Fibre'">bolt</v-icon>
              <v-icon v-else>podcasts</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >{{ addressinfo.name }}
                <i>({{ addressinfo.abbreviation }})</i></v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 14px">{{
                addressinfo.locationNode.name
              }}</v-list-tile-sub-title>
              <v-list-tile-sub-title
                style="font-size: 14px"
                v-if="addressinfo.region"
                >{{ addressinfo.region }}</v-list-tile-sub-title
              >
            </v-list-tile-content>
            <v-list-tile-action style="font-size: 14px">
              <v-chip
                style="height: 18px"
                v-if="addressinfo.networkStatus == 'Live'"
                color="green"
                class="white--text"
                >Live</v-chip
              >
              <v-chip
                style="height: 18px"
                v-else-if="addressinfo.networkStatus == 'In Progress'"
                color="blue"
                class="white--text"
                >In Progress</v-chip
              >
              <v-chip
                style="height: 18px"
                v-else-if="addressinfo.networkStatus == 'Planned'"
                color="orange"
                class="white--text"
                >Planned</v-chip
              >
            </v-list-tile-action>
          </v-list-tile>
        </v-list>

        <v-subheader style="background: #f0f0f0">
          Address <v-spacer></v-spacer>
          <v-btn
            round
            color="primary"
            class="white--text"
            v-if="polyData.length > 0 && editPolygon"
            @click="updatePolygon()"
            >Save</v-btn
          >
          <v-btn round v-else-if="polyData.length > 0 && !editPolygon" @click="editPolygon = true" icon>
                    <v-icon>edit</v-icon>
                </v-btn>
          <v-btn
            round
            color="error"
            class="white--text"
            v-if="polyData.length > 0 && !editPolygon"
            @click="deletePolygon()"
            icon
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn
            v-else-if="!addPolygon && polyData.length == 0"
            round
            color="primary"
            dark
            icon
            @click="addPolygon = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn
            v-else-if="addPolygon"
            round
            color="primary"
            dark
            @click="saveNewPolygon()"
            >Save</v-btn
          >
        </v-subheader>

        <v-layout justify-center>
          <v-flex xs10 mx-1>
            <v-text-field
              v-model="searchLocation"
              id="pac-input"
              clearable
              placeholder="Find Address"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-container grid-list-xs>
          <v-layout wrap style="height: 40vh">
            <gmap-map
              ref="mapRef"
              :center="center"
              :zoom="zoom"
              :options="{
                streetViewControl: false,
              }"
              style="width: 100%; height: 100%"
              @click="
                !addPolygon ? getAddressData($event) : addPolyPoint($event)
              "
            >
              <gmap-marker
                :position="center"
                :draggable="editPolygon"
                @dragend="getAddressData($event)"
              ></gmap-marker>
              <gmap-polygon
                :paths="polyData"
                :editable="editPolygon"
                :options="{
                  strokeColor: $store.state.currentOrg.org.primaryColour,
                  fillOpacity: 0.3,
                  strokeWeight: 2,
                  fillColor: $store.state.currentOrg.org.primaryColour,
                }"
                @paths_changed="savePolyData($event)"
                @click="getAddressData($event)"
              ></gmap-polygon>
              <gmap-polygon
                :paths="newPolyData"
                :editable="addPolygon"
                :options="{
                  strokeColor: $store.state.currentOrg.org.primaryColour,
                  fillOpacity: 0.3,
                  strokeWeight: 2,
                  fillColor: $store.state.currentOrg.org.primaryColour,
                }"
                @paths_changed="updateNewPolygon($event)"
              ></gmap-polygon>
              <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen = false"
                :key="key"
              >
                <v-card
                  flat
                  color="white"
                  :key="key"
                  v-if="
                    infoWindowContent && infoWindowContent.formatted_address
                  "
                >
                  <v-card-title flat color="primary">
                    <h3 class="title grey--text">
                      {{ infoWindowContent.formatted_address }}
                    </h3>
                  </v-card-title>
                  <v-card-actions>
                    <v-layout justify-center>
                      <v-btn
                        round
                        color="primary"
                        class="white--text"
                        @click="setPosition(infoWindowContent)"
                        >Update Position</v-btn
                      >
                    </v-layout>
                  </v-card-actions>
                </v-card>
                <v-card v-else flat color="white">
                  <v-card-text>
                    <v-layout justify-center wrap>
                      <v-flex xs10>
                        <v-progress-circular
                          size="30"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-flex>
                      <v-flex xs8>
                        <h3 class="grey--text">Getting address information</h3>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </gmap-info-window>
            </gmap-map>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex
        xs12
        md4
        style="
          border-left: 1px solid lightgrey;
          border-right: 1px solid lightgrey;
          border-bottom: 1px solid lightgrey;
        "
      >
        <v-list subheader>
          <v-subheader style="background: #f0f0f0">
            Data Service Settings <v-spacer></v-spacer>
            <v-btn icon @click="editDataService = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>router</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Installation fee</v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 14px">
                Residential
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span
                style="font-size: 14px"
                v-if="
                  addressinfo.routerInstallationFee &&
                  addressinfo.residentialRouterInstallationFeeAmount
                "
                >{{
                  addressinfo.residentialRouterInstallationFeeAmount | currency
                }}</span
              >
              <v-icon color="red" v-else>cancel</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>router</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Installation fee</v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 14px">
                Business
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span
                style="font-size: 14px"
                v-if="
                  addressinfo.routerInstallationFee &&
                  addressinfo.businessRouterInstallationFeeAmount
                "
                >{{
                  addressinfo.businessRouterInstallationFeeAmount | currency
                }}</span
              >
              <v-icon color="red" v-else>cancel</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>manage_accounts</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Setup Fee</v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 12px">
                Charged to all new activations
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span
                style="font-size: 14px"
                v-if="
                  addressinfo.activationFee && addressinfo.activationFeeAmount
                "
                >{{ addressinfo.activationFeeAmount | currency }}</span
              >
              <v-icon color="red" v-else>cancel</v-icon>
              <small
                v-if="
                  addressinfo.activationFee && addressinfo.activationFeeAmount
                "
                >excl VAT</small
              >
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon>miscellaneous_services</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Monthly Line Rental Fee</v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 12px">
                Record seperate monthly line rental fee
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <span
                style="font-size: 14px"
                v-if="
                  addressinfo.residentialLineRentalValue &&
                  addressinfo.residentialLineRentalValue
                "
                >{{ addressinfo.residentialLineRentalValue | currency }}</span
              >
              <v-icon color="red" v-else>cancel</v-icon>
              <small
                v-if="
                  addressinfo.residentialLineRentalValue &&
                  addressinfo.residentialLineRentalValue
                "
                >excl VAT</small
              >
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon>miscellaneous_services</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Monthly Line Rental Fee</v-list-tile-title
              >
              <v-list-tile-sub-title style="font-size: 12px">
                Monthly Line Rental fee included in levy
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon v-if="addressinfo.lineRentalIncluded" color="green"
                >check</v-icon
              >
              <v-icon color="red" v-else>cancel</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-if="addressinfo.lineRentalIncluded">
            <v-list-tile-action>
              <v-icon>group</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title style="font-size: 14px"
                >Levy Charged to one HOA/BC</v-list-tile-title
              >
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon
                v-if="addressinfo.hasSingleLineRentalCustomer"
                color="green"
                >check</v-icon
              >
              <v-icon color="red" v-else>cancel</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>

      <v-flex
        xs12
        md4
        style="
          border-left: 1px solid lightgrey;
          border-right: 1px solid lightgrey;
          border-bottom: 1px solid lightgrey;
        "
      >
        <v-list subheader>
          <v-subheader style="background: #f0f0f0">
            Sub Complexes <v-spacer></v-spacer>
            <v-btn icon @click="addSubComplexModal = true">
              <v-icon>add</v-icon>
            </v-btn>
          </v-subheader>
          <v-data-table
            :headers="subComplexHeaders"
            :items="subcomplexes"
            item-key="id"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="justify-center layout px-0">
                <v-icon small @click="editSubComplex(props.item)"
                  >settings</v-icon
                >
              </td>
              <td class="text-xs-center">{{ props.item.subComplexName }}</td>
              <td
                class="text-xs-center"
                v-if="props.item.customerOrganisationId !== null"
              >
                {{ props.item.customerOrganisation.name }}
              </td>
              <td class="text-xs-center" v-else></td>
            </template>
          </v-data-table>
          <v-subheader style="background: #f0f0f0">
            Resellers/Partners<v-spacer></v-spacer>
            <v-btn icon @click="addFibreFarmerModal = true">
              <v-icon>add</v-icon>
            </v-btn>
          </v-subheader>
          <v-data-table
            :headers="headers"
            :items="networkfibrefarmers"
            item-key="id"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="justify-center layout px-0">
                <v-icon small @click="edit(props.item)">settings</v-icon>
                <v-icon small @click="deleteFibreFarmer(props.item)"
                  >delete</v-icon
                >
              </td>
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td class="text-xs-center">
                {{ props.item.customerOrganisation.name }}
              </td>
            </template>
          </v-data-table>
        </v-list>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="addFibreFarmerModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">ADD FIBRE FARMER TO NETWORK</h1>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select A Fibre Farmer"
                  item-text="name"
                  item-value="id"
                  :items="allfibrefarmers"
                  v-model="editedItem.customerOrganisationId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                  :items="fibreFarmerTypes"
                  v-model="editedItem.type"
                  label="Fibre Farmer Type"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="editedItem.isInvestor"
                  label="Is this an invested partner?"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-if="editedItem.isInvestor"
                  v-model="editedItem.purchasedCpe"
                  label="Has the partner purchased CPE?"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.basProfitPercentage"
                  label="Percentage of BAS Profit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.vasProfitPercentage"
                  label="Percentage of VAS Profit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.basExpense"
                  label="Recurring BAS Expense"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.vasExpense"
                  label="Recurring VAS Expense"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="addFibreFarmer">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editFibreFarmerModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">EDIT FIBRE FARMER SETTINGS</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  hide-no-data
                  flat
                  color="primary"
                  label="*Select A Fibre Farmer"
                  item-text="name"
                  item-value="id"
                  :items="allfibrefarmers"
                  v-model="editedItem.customerOrganisationId"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-select
                  :items="fibreFarmerTypes"
                  v-model="editedItem.type"
                  label="Fibre Farmer Type"
                ></v-select>
                <!-- <v-text-field v-model="editedItem.type" label="Fibre Farmer Type"></v-text-field> -->
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-model="editedItem.isInvestor"
                  label="Is this an invested partner?"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-switch
                  v-if="editedItem.isInvestor"
                  v-model="editedItem.purchasedCpe"
                  label="Has the partner purchased CPE?"
                ></v-switch>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.basProfitPercentage"
                  label="Percentage of BAS Profit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.vasProfitPercentage"
                  label="Percentage of VAS Profit"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.basExpense"
                  label="Recurring BAS Expense"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.vasExpense"
                  label="Recurring VAS Expense"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="editFibreFarmerSettings"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="addSubComplexModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Add Sub Complex</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.subComplexName"
                  label="*Sub Complex Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  class="autoCompleteGlueTheme"
                  :items="customers"
                  :search-input.sync="search"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.customerOrganisationId"
                  flat
                  hide-details
                  label="Billable Organisation"
                  solo-inverted
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="saveSubComplex">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="editSubComplexModal" max-width="750px">
      <v-card>
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">Edit Sub Complex</h1>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-xs>
            <v-layout wrap>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="editedItem.subComplexName"
                  label="*Sub Complex Name"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-autocomplete
                  clearable
                  class="autoCompleteGlueTheme"
                  :items="customers"
                  :search-input.sync="search"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.customerOrganisationId"
                  flat
                  hide-details
                  label="Billable Organisation"
                  solo-inverted
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="justify-center layout px-0">
          <v-btn color="primary" round @click="close">Cancel</v-btn>
          <v-btn color="primary" round @click="updateSubComplex">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editGeneralInformation" width="750px" persistent>
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>General Information</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat @click="editGeneralInformation = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center wrap>
            <v-flex xs5 class="mx-1">
              <v-text-field
                box
                label="Network Name"
                v-model="addressinfo.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs5 class="mx-1">
              <v-text-field
                box
                label="Name Abbreviation"
                v-model="addressinfo.abbreviation"
              ></v-text-field>
            </v-flex>

            <v-flex xs5 class="mx-1">
              <v-select
                box
                :items="districts"
                item-text="name"
                item-value="id"
                v-model="addressinfo.licenseDistrictId"
                label="ICASA License District"
              ></v-select>
            </v-flex>
            <v-flex xs5 class="mx-1">
              <v-select
                box
                :items="locationnodes"
                item-text="name"
                item-value="id"
                v-model="addressinfo.locationNodeId"
                label="Node"
              ></v-select>
            </v-flex>

            <v-flex xs5 class="mx-1">
              <v-select
                box
                :items="networkStatus"
                v-model="addressinfo.networkStatus"
                label="Network Build Status"
              ></v-select>
            </v-flex>
            <v-flex xs5 class="mx-1">
              <v-select
                box
                :items="backhaulTypes"
                v-model="addressinfo.backhaulType"
                label="Backhaul Type"
              ></v-select>
            </v-flex>
            <v-flex xs5 class="mx-1">
              <v-text-field
                box
                label="Number of planned Units"
                v-model="addressinfo.totalPlannedUnits"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 class="text-xs-center">
              <v-btn flat color="primary" @click="save">Done</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDataService" width="750px" persistent>
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>Data Service Settings </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat @click="editDataService = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title style="font-size: 14px"
                  >Charge Installation Fee</v-list-tile-title
                >
              </v-list-tile-content>
              <v-list-tile-action>
                <v-switch
                  v-model="addressinfo.routerInstallationFee"
                ></v-switch>
              </v-list-tile-action>
            </v-list-tile>
            <v-layout justify-center wrap>
              <v-flex xs6>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-size: 14px"
                      >Installation Fee</v-list-tile-title
                    >
                    <v-list-tile-sub-title style="font-size: 14px"
                      >Residential</v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                  <v-list-tile-action style="width: 100px">
                    <v-text-field
                      style="font-size: 12px"
                      :disabled="!addressinfo.routerInstallationFee"
                      v-model="
                        addressinfo.residentialRouterInstallationFeeAmount
                      "
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>
              <v-flex xs6>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-size: 14px"
                      >Installation Fee</v-list-tile-title
                    >
                    <v-list-tile-sub-title style="font-size: 14px"
                      >Business</v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                  <v-list-tile-action style="width: 100px">
                    <v-text-field
                      style="font-size: 12px"
                      :disabled="!addressinfo.routerInstallationFee"
                      v-model="addressinfo.businessRouterInstallationFeeAmount"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>

              <v-flex xs12>
                <v-list-tile style="border-top: 1px solid lightgrey">
                  <v-list-tile-action>
                    <v-checkbox
                      v-model="addressinfo.activationFee"
                    ></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-size: 14px"
                      >Setup/Activation Fee</v-list-tile-title
                    >
                  </v-list-tile-content>
                  <v-list-tile-action style="width: 100px">
                    <v-text-field
                      style="font-size: 12px"
                      :disabled="!addressinfo.activationFee"
                      v-model="addressinfo.activationFeeAmount"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>
              <v-flex xs12>
                <v-subheader style="background: #f0f0f0"
                  >Monthly Line Rental Fee</v-subheader
                >
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>miscellaneous_services</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-sub-title style="font-size: 12px">
                      Monthly line rental fee
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action style="width: 100px">
                    <v-text-field
                      style="font-size: 12px"
                      v-model="addressinfo.residentialLineRentalValue"
                    ></v-text-field>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>miscellaneous_services</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <!-- <v-list-tile-title style="font-size: 14px">Monthly Line Rental Fee</v-list-tile-title> -->
                    <v-list-tile-sub-title style="font-size: 12px">
                      Monthly Line Rental fee included in levy
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-switch
                      v-model="addressinfo.lineRentalIncluded"
                    ></v-switch>
                  </v-list-tile-action>
                </v-list-tile>
                <v-list-tile v-if="addressinfo.lineRentalIncluded">
                  <v-list-tile-action>
                    <v-icon>group</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-sub-title style="font-size: 14px"
                      >Levy Charged to one HOA/BC</v-list-tile-sub-title
                    >
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-switch
                      v-model="addressinfo.hasSingleLineRentalCustomer"
                    ></v-switch>
                  </v-list-tile-action>
                </v-list-tile>
              </v-flex>

              <v-flex xs12 class="text-xs-center">
                <v-btn flat color="primary" @click="save">Done</v-btn>
              </v-flex>
            </v-layout>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import Api from "@/services/Api";
import { gmapApi } from "vue2-google-maps";
export default {
  props: [
    "addressinfo",
    "locationnodes",
    "networkfibrefarmers",
    "allfibrefarmers",
    "customers",
    "subcomplexes",
    "regions",
  ],
  data() {
    return {
      center: {
        lat: -33.919473,
        lng: 18.427059,
      },
      districts: [],
      zoom: 15,
      y: "top",
      snackbar: false,
      text: "",
      editGeneralInformation: false,
      editDataService: false,
      addFibreFarmerModal: false,
      editSubComplexModal: false,
      addSubComplexModal: false,
      editFibreFarmerModal: false,
      editPolygon: false,
      markerData: {},
      geocoder: null,
      infoWindowContent: {},
      currentPolyData: [],
      polyData: [],
      newPolyData: [],
      addPolygon: false,
      polygon: null,
      key: 0,
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      myStyles: [
        {
          featureType: "poi",
          elementType: "labels",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
      ],
      fibreFarmerTypes: ["Carrot Farmer", "Apple Farmer", "Grape Farmer"],
      networkStatus: ["Planned", "In Progress", "Live"],
      backhaulTypes: [
        "Open Band Wireless",
        "Licensed Wireless",
        "Fibre",
        "Hybrid",
      ],
      subComplexHeaders: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Sub Complex Name",
          align: "center",
          value: "subComplexName",
        },
        {
          text: "Customer",
          align: "center",
          value: "levyCustomer.name",
        },
      ],
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Fibre Farmer Type",
          align: "center",
          value: "type",
        },
        {
          text: "Organisation",
          align: "center",
          value: "customerOrganisation.name",
        },
      ],
      geoData: {},
      editedItem: {
        id: null,
        type: "",
        locationNetworkId: null,
        customerOrganisationId: null,
        vasProfitPercentage: 0,
        basProfitPercentage: 0,
        basExpense: 0,
        vasExpense: 0,
        isInvestor: false,
        purchasedCpe: false,
        subComplexName: "",
        levyCustomerId: null,
        isActive: true,
        isDeleted: false,
      },
      defaultItem: {
        id: null,
        type: "",
        locationNetworkId: null,
        customerOrganisationId: null,
        vasProfitPercentage: 0,
        basProfitPercentage: 0,
        basExpense: 0,
        vasExpense: 0,
        isInvestor: false,
        purchasedCpe: false,
        subComplexName: "",
        levyCustomerId: null,
        isActive: true,
        isDeleted: false,
      },
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    "$route.params.locationNetworkId": {
      handler: function (val) {
        if (val) {
          this.getNetworkPolygon();
          this.getLicenseDistricts();
        }
      },
      immediate: true,
    },
  },
  created() {},
  async mounted() {
    // console.log(this.addressinfo)

    // if (!this.addressinfo.geoLatitude || !this.addressinfo.geoLongitude) {
    //   this.geolocate();
    // }
    // setTimeout(() => {
    //   this.geocoder = new google.maps.Geocoder();
    // }, 3000);
  },
  methods: {
    async getLicenseDistricts() {
      Api()
        .get("/licenseDistricts")
        .then((res) => {
          this.districts = res.data;
        });
    },
    getNetworkPolygon() {
      this.polygon = {};
      this.polyData = [];
      Api()
        .get(
          "/locationNetworkPolygon/network/" +
            this.$route.params.locationNetworkId
        )
        .then((response) => {
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: {
                name: "urn:ogc:def:crs:OGC:1.3:CRS84",
              },
            },
            features: [],
          };
          if (response.data && response.data.coordinates) {
            this.polygon = response.data;

            let objects = [response.data];
            for (let x = 0; x < objects.length; x++) {
              let obj = {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: JSON.parse(objects[x].coordinates),
                },
              };

              if (obj.geometry.coordinates.length > 0) {
                if (
                  obj.geometry.coordinates[0][0][0] !==
                    obj.geometry.coordinates[0][
                      obj.geometry.coordinates[0].length - 1
                    ][0] ||
                  obj.geometry.coordinates[0][0][1] !==
                    obj.geometry.coordinates[0][
                      obj.geometry.coordinates[0].length - 1
                    ][1]
                ) {
                  obj.geometry.coordinates[0].push(
                    obj.geometry.coordinates[0][0]
                  );
                }
                geoObj.features.push(obj);
                this.center = {
                  lat: obj.geometry.coordinates[0][0][1],
                  lng: obj.geometry.coordinates[0][0][0],
                };
              }
            }
            let polyData = geoObj.features[0].geometry.coordinates
            this.polyData = polyData[0].map(x=>({lat: x[1], lng: x[0]}))
            console.log(this.polyData)
            //     this.center= {
            // lng: -33.919473,
            // lat: 18.427059
          }
          if (
            this.addressinfo.geoLatitude &&
            parseFloat(this.addressinfo.geoLatitude) != 0 &&
            this.addressinfo.geoLongitude &&
            parseFloat(this.addressinfo.geoLongitude) != 0
          ) {
            this.center = {
                  lat: parseFloat(this.addressinfo.geoLatitude),
                  lng: parseFloat(this.addressinfo.geoLongitude)
                };
            // google.maps.LatLng(
            //   this.addressinfo.geoLatitude,
            //   this.addressinfo.geoLongitude
            // );
          }
          this.geoData = geoObj;

          // if (result.length > 0) {
          // this.polygon = response.data;
          // this.polyData = result;
          // console.log(result)
          // this.plotMap();
          setTimeout(() => {
            this.plotMap();
          }, 300);

          // }
         
        });
    },
    savePolyData(data) {
      let keys = Object.keys(data);
      let find = keys.find((x) => Array.isArray(data[x]));
      let array = data[find][0][find].map((x) => [x.lng(), x.lat()]);
      // let array = data.i[0].i.map((x) => [x.lng(), x.lat()]);
      this.currentPolyData = [array];
    },
    updatePolygon() {
      if (this.currentPolyData.length > 0) {
        Api()
          .put("/locationNetworkPolygon/" + this.polygon.id, {
            coordinates: JSON.stringify(this.currentPolyData),
          })
          .then((response) => {
            this.editPolygon = false;
          });
      } else {
        this.editPolygon = false;
      }
    },
    getCenterOfPolygon(data) {
      var PI = 22 / 7;
      var X = 0;
      var Y = 0;
      var Z = 0;
      let polygon = new google.maps.Polygon(data);
      polygon.getPath().forEach(function (vertex, inex) {
        let lat1 = vertex.lat();
        let lon1 = vertex.lng();
        lat1 = (lat1 * PI) / 180;
        lon1 = (lon1 * PI) / 180;
        X += Math.cos(lat1) * Math.cos(lon1);
        Y += Math.cos(lat1) * Math.sin(lon1);
        Z += Math.sin(lat1);
      });
      let Lon = Math.atan2(Y, X);
      let Hyp = Math.sqrt(X * X + Y * Y);
      let Lat = Math.atan2(Z, Hyp);
      Lat = (Lat * 180) / PI;
      Lon = (Lon * 180) / PI;
      return new google.maps.LatLng(Lat, Lon);
    },
    plotMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.map = map;
        // let coordinates = this.polyData.map(x => [x.lat(), x.lng()])
        // let obj = {
        //     type: "Feature",
        //     properties: {
        //         // name: this.poly[x].name,
        //         // fno: objects[x].organisation,
        //         // network: objects[x],
        //         tessellate: 1,
        //     },
        //     geometry: {
        //         type: "Polygon",
        //         coordinates: [coordinates],
        //     },
        // };
        // console.log(obj)

        // this.map.data.addGeoJson(this.geoData);
        // if(obj.geometry.coordinates[0][0]){
        //   this.center = {lat: obj.geometry.coordinates[0][0][0], lng: obj.geometry.coordinates[0][0][1]}
        //   console.log(this.center)
        // }

        this.map.data.setStyle((feature) => {
          return {
            fillColor: this.$store.state.currentOrg.org.primaryColour,
            fillOpacity: 0.5,
            strokeWeight: 2,
            strokeColor: this.$store.state.currentOrg.org.primaryColour,
          };
        });
        this.initMapAutocomplete();
      });
      
    },
    editSubComplex(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedItem = Object.assign({}, item);
        this.editSubComplexModal = true;
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    addPolyPoint(data) {
      console.log(data)
      this.newPolyData.push(
        {
            lat: data.latLng.lat(),
            lng: data.latLng.lng()
        }
      );
    },
    saveNewPolygon() {
      // this.newPolyData = [array];
      // let data = this.newPolyData.map((x) => [x.lng(), x.lat()]);
      let data = this.newPolyData;
      console.log(this.newPolyData)
      data = data.map((x) => [x.lng, x.lat]);
      console.log(data)
      data.push(data[0]);
      data = [data];
      if (!this.polyData || this.polyData.length == 0) {
        Api()
          .post("/locationNetworkPolygon", {
            locationNetworkId: this.$route.params.locationNetworkId,
            coordinates: JSON.stringify(data),
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.addPolygon = false;
            this.polyData = [data[0].map(x=>({lat: x[0], lng: x[1]}))];
          });
      } else {
        Api()
          .put("/locationNetworkPolygon/" + this.polygon.id, {
            coordinates: JSON.stringify(data),
          })
          .then((response) => {
            this.addPolygon = false;
            // this.polyData = data;
            this.polyData = [data[0].map(x=>({lat: x[0], lng: x[1]}))];

          });
      }
    },
    updateNewPolygon(data) {
      let key = Object.keys(data)[0];
      console.log('key', key, data)
      let array = data[key][0][key].map((x) => ({lng: x.lng(), lat: x.lat()}));
      // let array = data.i[0].i.map((x) => [x.lng(), x.lat()]);
      this.newPolyData = array;
      // this.newPolyData = data.i[0].i;
    },
    deletePolygon() {
      confirm("Are you sure you want to delete the coverage polygon?") &&
        Api()
          .put("/locationNetworkPolygon/" + this.polygon.id, {
            isActive: false,
            isDeleted: true,
          })
          .then(() => {
            this.getNetworkPolygon();
          });
    },
    updateSubComplex(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/locationNetworkSubComplex/" + this.editedItem.id, {
            subComplexName: this.editedItem.subComplexName,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            locationNetworkId: this.$route.params.locationNetworkId,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("subComplexUpdate"), (this.editSubComplexModal = false);
          });
      }
    },

    saveSubComplex() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/locationNetworkSubComplex", {
            subComplexName: this.editedItem.subComplexName,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            locationNetworkId: this.$route.params.locationNetworkId,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("subComplexUpdate"), (this.addSubComplexModal = false);
          });
      }
    },
    edit(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        this.editedItem = Object.assign({}, item);
        this.editFibreFarmerModal = true;
      }
    },
    setPosition(item) {
      let streetNumber = item.address_components.find(
        (x) => x.types.filter((y) => y === "street_number").length > 0
      );
      let streetName = item.address_components.find(
        (x) => x.types.filter((y) => y === "route").length > 0
      );
      let suburb = item.address_components.find(
        (x) => x.types.filter((y) => y === "sublocality").length > 0
      );
      let city = item.address_components.find(
        (x) => x.types.filter((y) => y === "locality").length > 0
      );
      let country = item.address_components.find(
        (x) => x.types.filter((y) => y === "country").length > 0
      );
      let postalCode = item.address_components.find(
        (x) => x.types.filter((y) => y === "postal_code").length > 0
      );
      let obj = {
        geoLatitude: this.infoWindowPos.lat,
        geoLongitude: this.infoWindowPos.lng,
        streetNumber: streetNumber ? streetNumber.short_name : null,
        streetName: streetName ? streetName.short_name : null,
        town: city ? city.short_name : null,
        suburb: suburb ? suburb.short_name : null,
        city: city ? city.short_name : null,
        country: country ? country.short_name : null,
        postalCode: postalCode ? postalCode.short_name : null,
      };
      Api()
        .put("/locationNetworks/" + this.$route.params.locationNetworkId, obj)
        .then((response) => {
          this.center = this.infoWindowPos;
          this.addressinfo.geoLatitude = obj.geoLatitude;
          this.addressinfo.geoLongitude = obj.geoLongitude;
          this.addressinfo.streetNumber = obj.streetNumber;
          this.addressinfo.streetName = obj.streetName;
          this.addressinfo.suburb = obj.suburb;
          this.addressinfo.town = obj.town;
          this.addressinfo.city = obj.city;
          this.addressinfo.country = obj.country;
          this.addressinfo.postalCode = obj.postalCode;

          this.infoWinOpen = false;
          this.infoWindowContent = {};
          this.infoWindowPos = {
            lat: 0,
            lng: 0,
          };
        });
    },
    getAddressData: async function (addressData, placeResultData, id) {
      var latlng = new google.maps.LatLng(
        addressData.latLng.lat(),
        addressData.latLng.lng()
      );
      this.infoWindowPos = {
        lat: addressData.latLng.lat(),
        lng: addressData.latLng.lng(),
      };
      let resultData = null;
      let geocoder = new google.maps.Geocoder();
      await geocoder.geocode(
        {
          latLng: latlng,
        },
        async function (results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              resultData = results[1];
            } else {
              alert("No results found");
            }
          } else {
            alert("Geocoder failed due to: " + status);
          }
        }
      );
      setTimeout(() => {
        this.infoWindowContent = resultData;
        this.key += 1;
      }, 1500);
      setTimeout((this.infoWinOpen = true), 1600);
    },
    editFibreFarmerSettings() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/fibrefarmerlocationnetwork/" + this.editedItem.id, {
            locationNetworkId: this.$route.params.locationNetworkId,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            type: this.editedItem.type,
            vasProfitPercentage: this.editedItem.vasProfitPercentage,
            basProfitPercentage: this.editedItem.basProfitPercentage,
            vasExpense: this.editedItem.vasExpense,
            basExpense: this.editedItem.basExpense,
            isInvestor: this.editedItem.isInvestor,
            purchasedCpe: this.editedItem.purchasedCpe,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("fibreFarmerSettingsUpdated");
            this.close();
          });
      }
    },
    async initMapAutocomplete() {
      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input, {});
      autocomplete.setComponentRestrictions({
        country: ["za"],
      });
      google.maps.event.addListener(autocomplete, "place_changed", async () => {
        const place = autocomplete.getPlace();
        const location = place.geometry.location;

        var latlng = new google.maps.LatLng(location.lat(), location.lng());
        this.infoWindowPos = {
          lat: location.lat(),
          lng: location.lng(),
        };
        let resultData = null;
        let geocoder = new google.maps.Geocoder();
        await geocoder.geocode(
          {
            latLng: latlng,
          },
          async function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[1]) {
                resultData = results[1];
              } else {
                alert("No results found");
              }
            } else {
              alert("Geocoder failed due to: " + status);
            }
          }
        );
        setTimeout(() => {
          this.infoWindowContent = resultData;
          this.key += 1;
        }, 1500);
        setTimeout((this.infoWinOpen = true), 1600);
      });
    },
    close() {
      (this.addSubComplexModal = false),
        (this.editSubComplexModal = false),
        (this.addFibreFarmerModal = false);
      this.editFibreFarmerModal = false;

      this.editedItem = Object.assign({}, this.defaultItem);
    },

    deleteFibreFarmer(item) {
      this.editedItem = Object.assign({}, item);
      if (this.authDelete(this.$store.state.currentRoute)) {
        confirm(
          "Are you sure you want to remove this Fibre Farmer from this Network?"
        ) &&
          Api()
            .put("/fibrefarmerlocationnetwork/" + this.editedItem.id, {
              locationNetworkId: this.$route.params.locationNetworkId,
              customerOrganisationId: this.editedItem.customerOrganisationId,
              type: this.editedItem.type,
              vasProfitPercentage: this.editedItem.vasProfitPercentage,
              basProfitPercentage: this.editedItem.basProfitPercentage,
              vasExpense: this.editedItem.vasExpense,
              basExpense: this.editedItem.basExpense,
              isInvestor: this.editedItem.isInvestor,
              purchasedCpe: this.editedItem.purchasedCpe,
              isActive: false,
              isDeleted: true,
            })
            .then((response) => {
              this.$emit("fibreFarmerSettingsUpdated");
              this.close();
            });
      }
    },
    addFibreFarmer() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        Api()
          .post("/fibrefarmerlocationnetwork", {
            locationNetworkId: this.$route.params.locationNetworkId,
            customerOrganisationId: this.editedItem.customerOrganisationId,
            type: this.editedItem.type,
            vasProfitPercentage: this.editedItem.vasProfitPercentage,
            basProfitPercentage: this.editedItem.basProfitPercentage,
            vasExpense: this.editedItem.vasExpense,
            basExpense: this.editedItem.basExpense,
            isInvestor: this.editedItem.isInvestor,
            purchasedCpe: this.editedItem.purchasedCpe,
            isActive: true,
            isDeleted: false,
          })
          .then((response) => {
            this.$emit("fibreFarmerSettingsUpdated");
            this.close();
          });
      }
    },
    save() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        let proceed = true;

        if (
          this.addressinfo.lineRentalIncluded == true &&
          this.addressinfo.residentialLineRentalValue == null
        ) {
          proceed = false;
          confirm("Please fill in the Monthly Access Fee amount");
        }
        if (proceed == true) {
          Api()
            .put("/locationnetworks/" + this.$route.params.locationNetworkId, {
              name: this.addressinfo.name,
              abbreviation: this.addressinfo.abbreviation,
              locationNodeId: this.addressinfo.locationNodeId,
              lineRentalIncluded: this.addressinfo.lineRentalIncluded,
              licenseDistrictId: this.addressinfo.licenseDistrictId,
              residentialLineRentalValue:
                this.addressinfo.residentialLineRentalValue,
              businessLineRentalValue: this.addressinfo.businessLineRentalValue,
              tvOverFibre: this.addressinfo.tvOverFibre,
              gtuIncluded: this.addressinfo.gtuIncluded,
              gtuFee: this.addressinfo.gtuFee,
              activationFee: this.addressinfo.activationFee,
              activationFeeAmount: this.addressinfo.activationFeeAmount,
              routerInstallationFee: this.addressinfo.routerInstallationFee,
              customerOrganisationId: this.addressinfo.customerOrganisationId,
              residentialRouterInstallationFeeAmount:
                this.addressinfo.residentialRouterInstallationFeeAmount,
              businessRouterInstallationFeeAmount:
                this.addressinfo.businessRouterInstallationFeeAmount,
              hasSingleLineRentalCustomer:
                this.addressinfo.hasSingleLineRentalCustomer,
              networkStatus: this.addressinfo.networkStatus,
              backhaulType: this.addressinfo.backhaulType,
              streetNumber: this.addressinfo.streetNumber,
              streetName: this.addressinfo.streetName,
              suburb: this.addressinfo.suburb,
              town: this.addressinfo.town,
              city: this.addressinfo.city,
              country: this.addressinfo.country,
              postalCode: this.addressinfo.postalCode,
              geoLongitude: this.addressinfo.geoLongitude,
              geoLatitude: this.addressinfo.geoLatitude,
              geoHightAboveGroundLevel:
                this.addressinfo.geoHightAboveGroundLevel,
              isMDU: this.addressinfo.isMDU,
              regionId: this.addressinfo.regionId,
              totalPlannedUnits: this.addressinfo.totalPlannedUnits,
            })
            .then((response) => {
              if (response.status === 200) {
                this.text = `Successfully Saved Changes!`;
                this.snackbar = true;
              }
              this.editDataService = false;
              this.editGeneralInformation = false;
            });
        }
      }
    },
  },
};
</script>

<style>
.autoCompleteGlueTheme {
  border-bottom: 1px solid grey !important;
  color: black !important;
}

.theme--light.v-text-field--solo-inverted.v-text-field--solo
  > .v-input__control
  > .v-input__slot {
  background-color: transparent !important;
  color: black !important;
}

.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  .v-label,
.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  input {
  color: black !important;
}
</style>
